import { render, staticRenderFns } from "./StartseiteAngebote.vue?vue&type=template&id=55dcda84"
import script from "./StartseiteAngebote.vue?vue&type=script&lang=js"
export * from "./StartseiteAngebote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports